import { render, staticRenderFns } from "./menu_admin.vue?vue&type=template&id=95b00abc&"
import script from "./menu_admin.vue?vue&type=script&lang=js&"
export * from "./menu_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports